import React from 'react';
import './styles.css';

const Education = ({ isDarkMode }) => {
    // Throw an error if isDarkMode prop isn't provided
    if (isDarkMode === undefined) {
        throw new Error('isDarkMode prop is required for Education component');
    }

    return (
        <div className="mainArea transition-effect" id="education-section">
            <div className="education transition-effect">
                <div className="leftArea">
                    <img
                        src="/images/siteElements/aboutMe/schools.png"
                        alt="Education Top"
                        className="topImg"
                    />

                    <div className="contentArea">
                        <div className="leftContent ">
                            <div className="sectionTitle">
                                Education
                            </div>

                            <img
                                src="/images/siteElements/scroll-both.png"
                                alt="Scroll Both Indicator"
                                className="eduScrollBoth" />
                        </div>
                        <div className="rightContent">
                            <div className="educationItem">
                                <p className="eduTitle">
                                    B.Tech + MS in CSE by Research
                                    <span className="eduPeriod">2023 - 2028</span>
                                </p>
                                <p className="eduSchool">International Institute of Information Technology (IIIT), Hyderabad</p>
                                <p className="eduDesc">Currently in my fourth year with 8.5 CGPA. Research focus on Software Engineering
                                    under the guidance of Prof. Karthik Vaidhyanathan at SERC.</p>
                            </div>

                            <div className="educationItem">
                                <p className="eduTitle">
                                    Class XII - CBSE
                                    <span className="eduPeriod">2021 - 2023</span>
                                </p>
                                <p className="eduSchool">The Mother's International School, Delhi</p>
                                <p className="eduDesc">Achieved 92.6% and was part of the school's tech club,
                                    MINET. As a programming team lead helped organise and participated (and won) in
                                    various tech events.</p>
                            </div>

                            <div className="educationItem">
                                <p className="eduTitle">
                                    Class X - CBSE
                                    <span className="eduPeriod">2009 - 2021</span>
                                </p>
                                <p className="eduSchool">Ramjas International School, Delhi</p>
                                <p className="eduDesc">Scored 93.3%. As part of the Atal Innovation Mission,
                                    built and worked on many real-world solutions and product prototypes;
                                    receiving various awards and national-level recognition.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="rightArea">
                    <img
                        src="/images/siteElements/aboutMe/college.png"
                        alt="Education Right"
                        className="rightImg"
                    />
                </div>
            </div>
        </div>
    );
};

export default Education;